import { Helmet } from "react-helmet-async"
import { ReactComponent as IconArrowLeft } from "../../../../assets/img/workshops/arrow-left.svg"
import { ReactComponent as IconCheck } from "../../../../assets/img/workshops/checkmark.svg"
import { ReactComponent as IconChevronDown } from "../../../../assets/img/workshops/chevron-down.svg"
import { ReactComponent as IconDevices } from "../../../../assets/img/workshops/devices.svg"
import { ReactComponent as IconFile } from "../../../../assets/img/workshops/file.svg"
import { ReactComponent as IconOnline } from "../../../../assets/img/workshops/online.svg"
import { ReactComponent as IconWifi } from "../../../../assets/img/workshops/wifi.svg"

import ImageRaquel from "../../../../assets/img/workshops/image-raquel.png"
import { Link } from "react-router-dom"

import "./detail.css"

const FastingPage = () => {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_FRONT_URL}/productos/taller-ayuno-intermitente`}
        />
        <title>Taller de Ayuno Intermitente | Aprende a hacerlo bien</title>
        <meta
          name="description"
          content="Entiende qué es el ayuno intermitente, cómo funciona y cómo integrarlo de forma segura en tu estilo de vida con los expertos de Vikika Team."
        />
        <meta
          name="keywords"
          content="ayuno intermitente, cómo hacer ayuno, salud digestiva, hábitos saludables, metabolismo, bienestar, Vikika Team, taller ayuno"
        />
        <meta property="og:title" content="Taller de Ayuno Intermitente | Aprende a hacerlo bien" />
        <meta
          property="og:description"
          content="Entiende qué es el ayuno intermitente, cómo funciona y cómo integrarlo de forma segura en tu estilo de vida con los expertos de Vikika Team."
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_FRONT_URL}/productos/taller-ayuno-intermitente`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_FRONT_URL}/img/workshops/ayuno.png`}
        />
      </Helmet>

      <main className="main-content">
        <div className="workshops-page">
          <header
            className="workshops-detail-hero"
            style={{ backgroundColor: "var(--color-secondary-purple-light)" }}
          >
            <div className="workshops-detail-hero-content">
              <div className="workshops-chip">
                <IconOnline />
                <p>Online</p>
              </div>
              <h1 className="workshops-detail-hero-title">Guía del ayuno intermitente</h1>
              <p className="workshops-detail-hero-description">
                En este taller descubrirás qué es realmente el ayuno intermitente, cómo adaptarlo y
                cuáles son las claves para hacerlo de forma segura y sostenible. Aprenderás a
                escucharte, a conocer qué protocolos existen y cómo integrarlos sin rigidez, para
                que el ayuno se convierta en un aliado y no en una obligación.
              </p>
              <div className="workshops-detail-hero-footer">
                <div className="workshops-detail-hero-info">
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Duración</p>
                    <p className="value">1h 10min</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Impartido por</p>
                    <p className="value">Raquel</p>
                  </div>
                  <div className="workshops-detail-hero-info-data">
                    <p className="label">Precio</p>
                    <p className="value">19,99€</p>
                  </div>
                </div>
                <a
                  href="https://vikika-team-s-school.teachable.com/l/pdp/guia-del-ayuno-intermitente"
                  className="workshops-btn workshops-btn-primary"
                >
                  Me apunto <IconArrowLeft className="workshops-btn-icon" />
                </a>
              </div>
            </div>
          </header>
          {/* Guía */}
          <section className="workshops-section workshops-guide">
            <h2 className="workshops-section-title">¿Qué aprenderás?</h2>
            <div className="workshops-guide-content">
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">1</span>
                  Qué es realmente el ayuno intermitente
                  <IconChevronDown />
                </summary>
                <p>
                  Rompe mitos y entiende en qué consiste esta práctica y qué beneficios puede
                  aportar.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">2</span>
                  Principales protocolos de ayuno
                  <IconChevronDown />
                </summary>
                <p>
                  Conoce los diferentes tipos de ayuno y cómo elegir el que mejor encaje contigo.
                </p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">3</span>Escuchar al cuerpo
                  <IconChevronDown />
                </summary>
                <p>Aprende a diferenciar señales de hambre real, saciedad y hábitos adquiridos.</p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">4</span>Errores más comunes
                  <IconChevronDown />
                </summary>
                <p>Descubre los mitos que existen acerca del ayuno intermitente.</p>
              </details>
              <details className="workshops-guide-step" name="guide-steps">
                <summary className="workshops-guide-step-launcher">
                  <span className="workshops-guide-number">5</span>Beneficios reales
                  <IconChevronDown />
                </summary>
                <p>
                  Conoce la evidencia científica sobre cómo el ayuno intermitente puede influir en
                  tu energía, tu metabolismo y tu bienestar.
                </p>
              </details>
            </div>
          </section>
          {/* Para ti */}
          <section className="workshops-section workshops-for-you">
            <h2 className="workshops-section-title">Estos talleres son para ti si…</h2>

            <div className="workshops-grid">
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Te interesa conocer con detalle</strong> en qué consiste el ayuno de la
                  mano de una profesional de la nutrición.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Has oído hablar del ayuno intermitente,</strong> tienes información
                  diversa pero no sabes con claridad cómo funciona esta estrategia nutricional.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Quieres diferenciar entre mitos y realidades</strong> sobre esta práctica
                  que has oído en redes o has visto en internet.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Buscas aprender cómo aplicarlo</strong> a tu estilo de vida sin caer en
                  rigideces extremas.
                </p>
              </div>
              <div className="workshops-card-simple">
                <IconCheck />
                <p>
                  <strong>Quieres herramientas claras, basadas en ciencia,</strong> para tomar tus
                  propias decisiones.
                </p>
              </div>
            </div>

            <div className="workshops-section-action">
              <a
                className="workshops-btn workshops-btn-primary"
                href="https://vikika-team-s-school.teachable.com/l/pdp/guia-del-ayuno-intermitente"
              >
                Me apunto <IconArrowLeft className="workshops-btn-icon" />
              </a>
            </div>
          </section>
          {/* Necesito */}
          <section className="workshops-section workshops-requirements">
            <h2 className="workshops-section-title">¿Qué necesito?</h2>
            <div className="workshops-requirements-content">
              <div className="workshops-requirements-item">
                <IconDevices />
                <p>
                  <strong>Ordenador o dispositivo móvil</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconWifi />
                <p>
                  <strong>Conexión a internet</strong>
                </p>
              </div>
              <div className="workshops-requirements-item">
                <IconFile />
                <p>
                  <strong>Ordenador o Lápiz y papel</strong> o un dispositivo donde puedas apuntar
                  tus notas
                </p>
              </div>
            </div>
          </section>
          <section className="workshops-section workshops-experts">
            <h2 className="workshops-section-title">Nuestros profesionales</h2>
            <p className="workshops-section-description">
              Este curso está guiado por nutricionistas especializados en ayuno intermitente y salud
              hormonal, que combinan la evidencia científica con la experiencia práctica en
              consulta. Te acompañarán con un enfoque cercano, adaptado a ti y a tus necesidades,
              para que el ayuno sea una herramienta de bienestar y no una carga
            </p>
            <article className="workshops-experts-card">
              <img className="workshops-experts-card-image" src={ImageRaquel} alt="Raquel Capel" />
              <div className="workshops-experts-card-content">
                <h3 className="workshops-experts-card-title">Raquel Capel</h3>
                <p className="workshops-experts-card-subtitle">
                  Dietista-nutricionista colegiada y entrenadora personal certificada NSCA-CPT y con
                  Certificado AFDA0210.
                </p>
                <div className="workshops-experts-card-description">
                  <p>
                    Dietista-nutricionista colegiada y entrenadora personal certificada NSCA-CPT y
                    con Certificado AFDA0210. Su enfoque es integrador en salud, educación
                    alimentaria y coaching. Acumula una sólida experiencia clínica y deportiva
                    trabajando incluso con futbolistas profesionales, y una intensa labor
                    divulgativa en medios como ABC Bienestar, RNE, etc.
                  </p>
                  <p>
                    Comprometida con la formación continua, ha participado en congresos y cursos,
                    así como formaciones técnicas tanto en el ámbito de la nutrición como de
                    entrenamiento lo que le permite ofrecer un acompañamiento científico, empático y
                    actualizado para transformar la salud de las personas desde la raíz.
                  </p>
                  <p>
                    Su sello distintivo es una estrategia no pesocentrista, enfocada en la salud
                    real y sostenible.
                  </p>
                </div>
              </div>
            </article>
          </section>
          <section className="workshops-section workshops-faqs">
            <h2 className="workshops-section-title">¿Tienes dudas?</h2>
            <div className="workshops-faqs-content">
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito tener conocimientos previos para hacer el taller?
                  <IconChevronDown />
                </summary>
                <p>
                  No. Está diseñado para cualquier persona que quiera aprender sobre el ayuno
                  intermitente.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Puedo ver los videos cuando quiera?
                  <IconChevronDown />
                </summary>
                <p>
                  Sí, podrás acceder a la grabación si no puedes asistir en directo y revisarlo
                  todas las veces que quieras.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Es un taller teórico o práctico?
                  <IconChevronDown />
                </summary>
                <p>
                  Ambos. Combina reflexiones y teoría con ejercicios prácticos. Los ejercicios serán
                  sencillos por lo que no te preocupes, no es una práctica compleja.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Cuánto dura y en qué formato se imparte?
                  <IconChevronDown />
                </summary>
                <p>
                  Aproximadamente 1h y 10 min, en formato online. Puedes conectarte desde cualquier
                  lugar.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito algún material especial?
                  <IconChevronDown />
                </summary>
                <p>Solo tu ordenador o móvil con conexión a internet y algo para tomar notas.</p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Quién imparte el taller y qué experiencia tiene?
                  <IconChevronDown />
                </summary>
                <p>
                  Raquel Capel Dietista-nutricionista colegiada y entrenadora personal certificada
                  NSCA-CPT, que cuenta con gran experencia clínica y deportiva así como divulgativa
                  para difernetes medios.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Necesito estar realizando ayuno intermitente para acceder al taller?
                  <IconChevronDown />
                </summary>
                <p>
                  No. No es necesario. Puedes estar realizando cualquier otro tipo de estrategia
                  nutricional o ninguna para realizar este taller.
                </p>
              </details>
              <details className="workshops-faqs-item" name="faqs">
                <summary className="workshops-faqs-item-launcher">
                  ¿Terminaré este taller teniendo un plan de ayuno intermitente para mí?
                  <IconChevronDown />
                </summary>
                <p>
                  No. En este taller no realizaremos una planificación nutricional, te explicaremos
                  qué es el ayuno intermitente, en qué consiste, cuáles son sus ventajas e
                  inconveniente y que beneficios tiene para la salud aplicándolo de forma correcta.
                </p>
              </details>
            </div>
          </section>
          {/* Contacto */}
          <section className="workshops-section workshops-contact">
            <div className="workshops-contact-content">
              <h2 className="workshops-section-title">¿Necesitas un enfoque más personalizado?</h2>
              <p className="workshops-text">
                Si necesitas un acompañamiento más personalizado, podemos ayudarte. Nuestro equipo
                de psicólogos clínicos y nutricionistas está aquí para guiarte y trabajar contigo
                para que puedas gestionar mejor todas las situaciones de la vida.
              </p>
              <Link to="/contacto/" className="workshops-btn workshops-btn-primary">
                Contacta con nosotras
              </Link>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}

export default FastingPage
